import { NavLink, useLocation } from "react-router-dom";
import { Home, LayoutGrid, ShoppingCart, User } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const NAV_ITEMS = [
  { to: "/", icon: Home, label: "Accueil", testid: "bottom-nav-home", exact: true },
  { to: "/products", icon: LayoutGrid, label: "Catégories", testid: "bottom-nav-categories" },
  { to: "/cart", icon: ShoppingCart, label: "Panier", testid: "bottom-nav-cart", showCartBadge: true },
];

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { count } = useCart();
  const { user } = useAuth();
  const accountTo = user ? "/account" : "/login";

  const items = [
    ...NAV_ITEMS,
    { to: accountTo, icon: User, label: "Compte", testid: "bottom-nav-account" },
  ];

  // Hide on admin and auth callback pages
  if (pathname.startsWith("/admin") || pathname.startsWith("/auth/callback")) return null;

  return (
    <>
      {/* Spacer so page content isn't hidden behind the fixed bar (mobile+tablet only) */}
      <div className="h-16 lg:hidden" aria-hidden="true" />
      <nav
        className="fixed bottom-0 left-0 right-0 z-40 lg:hidden je-glass-sticky-header border-t border-gray-200"
        style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
        data-testid="mobile-bottom-nav"
        aria-label="Navigation principale"
      >
        <ul className="grid grid-cols-4 max-w-3xl mx-auto">
          {items.map((it) => {
            const Icon = it.icon;
            const active = it.exact ? pathname === it.to : pathname === it.to || pathname.startsWith(it.to + "/") || (it.to === "/products" && pathname.startsWith("/products"));
            return (
              <li key={it.label}>
                <NavLink
                  to={it.to}
                  className={`flex flex-col items-center justify-center gap-0.5 py-2 min-h-[64px] transition ${active ? "text-[#0052CC]" : "text-gray-500 hover:text-gray-700"}`}
                  data-testid={it.testid}
                  aria-label={it.label}
                >
                  <div className="relative">
                    <Icon className={`w-6 h-6 transition-transform ${active ? "scale-110" : ""}`} strokeWidth={active ? 2.4 : 1.8} />
                    {it.showCartBadge && count > 0 && (
                      <span
                        className="absolute -top-1.5 -right-2 bg-[#E3000F] text-white text-[10px] font-bold min-w-[18px] h-[18px] rounded-full flex items-center justify-center px-1"
                        data-testid="bottom-nav-cart-badge"
                      >
                        {count > 99 ? "99+" : count}
                      </span>
                    )}
                  </div>
                  <span className={`text-[10.5px] font-semibold ${active ? "" : "opacity-90"}`}>{it.label}</span>
                  {active && <span className="absolute top-0 w-8 h-0.5 bg-[#0052CC] rounded-b-full" />}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
}
